module.exports = __webpack_public_path__ + "static/media/discord.1b364f86.svg";